module.exports = __webpack_public_path__ + "img/corbata.8cf0fa08.svg";